<style lang="scss">
.slide-9 {
  background-image: url(../../../assets/module1/slide9/background-01.jpg);
  background-size: cover;
  background-position: center;
  padding-top: 100px;
  padding-left: 130px;
  height: calc(100% - 100px);
  h1 {
    font-size: 80px;
    margin-bottom: 10px;
  }
  .content {
    max-width: 719px;
  }
  p {
    color: white;
    margin-bottom: 1em;
  }
  h2 {
    color: #f8dc61;
    font-size: 53px;
    text-align: center;
    transform: rotate(-5deg);
    span {
      display: block;
      font-size: 92px;
      &:last-of-type {
        transform: rotate(5deg) translateY(15px);
      }
    }
  }
  .para {
    max-width: 79%;
    margin-top: 1em;
    line-height: 40px;
  }
}
</style>

<template>
  <div class="slide-9">
    <transition name="fadeRight" appear>
      <img
        src="@/assets/module1/slide9/photos-01-b.png"
        v-show="slideIndex == 8"
        class="delay-4 chars"
      />
    </transition>
    <transition name="fadeRight" appear>
      <img
        src="@/assets/module1/slide9/timmy-01.png"
        v-show="slideIndex == 8"
        class="delay-4 chars"
      />
    </transition>
    <div class="content">
      <transition name="fadeUp" appear>
        <div v-show="slideIndex == 8">
          <h1>{{ $t("module1.slide9.heading") }}</h1>
        </div>
      </transition>
      <transition name="fadeUp" appear>
        <div v-show="slideIndex == 8" class="delay-1">
          <p>{{ $t("module1.slide9.intro") }}</p>
        </div>
      </transition>
      <transition name="fadeUp" appear>
        <div v-show="slideIndex == 8" class="delay-2">
          <h2 v-html="$t('module1.slide9.heading2')"></h2>
        </div>
      </transition>
      <transition name="fadeUp" appear>
        <div v-show="slideIndex == 8" class="delay-3">
          <p class="para">
            {{ $t("module1.slide9.paragraph") }}
          </p>
        </div>
      </transition>
    </div>
  </div>
</template>

<script>
export default {
  props: ["slideIndex"]
};
</script>
